/* KAOS STORE ROMA - sticky mobile add to cart, 03 Nov 2026.
   Uses the native Shopify product form: no duplicate cart calls.
   The bar is mounted on body to avoid transformed/clipped theme sections. */
(function () {
  if (customElements.get('kaos-mobile-buy')) return;

  class KaosMobileBuy extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.sourceSection = this.closest('.shopify-section');
      this.productInfo = this.sourceSection?.querySelector('product-info');
      this.action = this.querySelector('[data-kaos-sticky-action]');
      this.actionLabel = this.querySelector('[data-kaos-sticky-action-label]');
      this.price = this.querySelector('[data-kaos-sticky-price]');

      if (!this.sourceSection || !this.productInfo || !this.action) {
        this.hidden = true;
        return;
      }

      // Leaving the Shopify section prevents CSS transforms/animations from
      // changing what position:fixed means on mobile.
      this._moving = true;
      document.body.appendChild(this);
      this._moving = false;

      this.sizeConfirmed = !this.sizeField() || this.dataset.explicitVariant === 'true';
      this.schedule = () => this.scheduleUpdate();
      this.onChange = (event) => {
        if (this.sizeField()?.contains(event.target)) this.sizeConfirmed = true;
        this.scheduleUpdate();
      };
      this.onAction = () => {
        const original = this.nativeButton();
        if (!original) return;
        const size = this.sizeField();
        if (size && !this.sizeConfirmed) {
          size.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'center'
          });
          const target = size.querySelector('input:not([disabled]),select:not([disabled])');
          if (target) target.focus({ preventScroll: true });
          return;
        }
        const idField = this.variantId();
        if (!idField?.value || idField.disabled || original.disabled || original.classList.contains('loading')) return;
        original.click(); // Reuse native validation, cart drawer and inventory handling.
        this.scheduleUpdate();
      };

      this.action.addEventListener('click', this.onAction);
      this.productInfo.addEventListener('change', this.onChange);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      window.addEventListener('pageshow', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.productInfo, {
        subtree: true, childList: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class', 'value']
      });
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      if (this._moving || !this._ready) return;
      this.action?.removeEventListener('click', this.onAction);
      this.productInfo?.removeEventListener('change', this.onChange);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('pageshow', this.schedule);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      document.body.classList.remove('kaos-sticky-buy-visible');
      this._ready = false;
    }

    nativeButton() {
      return this.productInfo?.querySelector('product-form button[name="add"]');
    }

    variantId() {
      return this.productInfo?.querySelector('product-form input[name="id"]');
    }

    sizeField() {
      return Array.from(this.productInfo?.querySelectorAll('variant-selects .product-form__input, variant-radios .product-form__input') || [])
        .find((field) => /taglia|taglie|size|misura|dimensione|waist/i.test(
          field.querySelector('.form__label, legend')?.textContent || ''
        ));
    }

    refreshPrice() {
      const priceBlock = this.productInfo?.querySelector('[id^="price-"] .price');
      if (!priceBlock || !this.price) return;
      const selector = priceBlock.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale'
        : '.price__regular .price-item--regular';
      const price = priceBlock.querySelector(selector)?.textContent?.replace(/\s+/g, ' ').trim();
      if (price) this.price.textContent = price;
    }

    scheduleUpdate() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      if (!this.sourceSection?.isConnected || !this.productInfo?.isConnected) {
        this.hidden = true;
        document.body.classList.remove('kaos-sticky-buy-visible');
        return;
      }
      const original = this.nativeButton();
      if (!original) {
        this.hidden = true;
        document.body.classList.remove('kaos-sticky-buy-visible');
        return;
      }
      this.refreshPrice();
      const needsSize = !!this.sizeField() && !this.sizeConfirmed;
      const idField = this.variantId();
      const unavailable = !idField?.value || idField.disabled || original.disabled;
      const busy = original.classList.contains('loading') || original.getAttribute('aria-disabled') === 'true';
      this.actionLabel.textContent = needsSize ? 'SCEGLI TAGLIA' : unavailable ? 'ESAURITO' : busy ? 'ATTENDI...' : 'AGGIUNGI';
      this.action.disabled = busy || (unavailable && !needsSize);
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const pastOriginal = original.getBoundingClientRect().bottom < 0;
      const show = mobile && pastOriginal;
      this.hidden = !show;
      document.body.classList.toggle('kaos-sticky-buy-visible', show);
    }
  }

  customElements.define('kaos-mobile-buy', KaosMobileBuy);
})();
